var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoUnidoodleWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 680 192.03",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#023047;}.cls-2{fill:#fb8501;}"))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.41,46.4V87.71c0,21.33-13.08,32.25-31.22,32.25-17.3,0-32-10.51-32-32.25V46.4h13.5V87.71c0,13,7.42,19.89,18.65,19.89s17.62-7.53,17.62-19.89V46.4Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.15,118.41V91.83c0-7.72-4.22-13.6-12.26-13.6-7.73,0-13,6.49-13,14.22v26H233.44V67.52h11.23l.83,6.9c5.15-5,10.3-7.62,16.69-7.62,11.95,0,21.53,9,21.53,24.93v26.68Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.25,53.3c0,9.79-14.84,9.79-14.84,0S308.25,43.51,308.25,53.3Zm-13.7,14.12v51h12.57v-51Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.84,81.74c.31,18.23-10.82,36.67-36.06,36.67H318.45V46.3h28.33C371.51,46.3,382.53,63.91,382.84,81.74ZM332,105.33h14.83c16.38,0,22.88-12,22.57-23.7-.31-11.23-6.91-22.46-22.57-22.46H332Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M442.4,93.07c0,14.63-10,26.48-26.48,26.48s-26.38-11.85-26.38-26.48,10.1-26.48,26.28-26.48S442.4,78.54,442.4,93.07Zm-40.29,0c0,7.73,4.64,14.94,13.81,14.94s13.81-7.21,13.81-14.94-5.36-15-13.81-15C406.85,78,402.11,85.44,402.11,93.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M501.54,93.07c0,14.63-10,26.48-26.48,26.48s-26.37-11.85-26.37-26.48S458.78,66.59,475,66.59,501.54,78.54,501.54,93.07Zm-40.28,0c0,7.73,4.63,14.94,13.8,14.94s13.81-7.21,13.81-14.94-5.36-15-13.81-15C466,78,461.26,85.44,461.26,93.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M563,46.4v72H551.21l-.83-7c-3.91,6.08-10.2,8.14-16.38,8.14-14.94,0-26.17-9.89-26.17-26.59,0-17.51,11-26.57,25.86-26.57,5.36,0,13.7,2.88,16.69,8.14V46.4ZM520.4,93c0,8.87,6.39,15,14.42,15s14.74-5.78,14.74-15a14.5,14.5,0,0,0-14.74-14.83C526.79,78.13,520.4,83.8,520.4,93Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.34,46.4v72H573.88v-72Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M608.09,97.5c.82,6.28,6.28,10.82,15.14,10.82,4.64,0,10.72-1.76,13.6-4.74l8,7.93c-5.36,5.57-14.12,8.24-21.84,8.24-17.52,0-27.92-10.81-27.92-27.09,0-15.46,10.5-26.58,27-26.58,17,0,27.61,10.51,25.65,31.42ZM635.7,87.09c-.83-6.59-6-9.89-13.19-9.89-6.8,0-12.36,3.3-14.22,9.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.1,19.7v96H62.55v-.36a33.45,33.45,0,0,1,23.3-31.84L96,93.59l10.12-10.12a33.45,33.45,0,0,1,23.3,31.84v4.32l-22.13,19.3a33,33,0,0,0-41.66,0l-22.13-19.3V61.45H32v63.37l54.4,47.51,54.42-47.51V19.7ZM86.42,157.13l-12-10.5a21.63,21.63,0,0,1,24,0ZM96,70.44a9,9,0,1,1,9-9A9,9,0,0,1,96,70.44Zm33.42,15a45,45,0,0,0-17-11.9,20.44,20.44,0,1,0-32.84,0,45,45,0,0,0-17,11.9V31.15h18.7V32a5.23,5.23,0,0,0,5.23,5.24h19A5.24,5.24,0,0,0,110.69,32v-.83h18.7Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.69,115.67a6.94,6.94,0,0,0,6.94-6.94v-6.94H103.75v6.94a6.94,6.94,0,0,0,6.94,6.94",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUnidoodleWhite);
export default __webpack_public_path__ + "static/media/logo_unidoodle_white.f20065579256e7282a47d4e5cbce42dc.svg";
export { ForwardRef as ReactComponent };